module.exports = __webpack_public_path__ + "img/Geo.15b3f619.svg";